'use strict';

var Consts = require('consts');
var BaseDeviceSettingsView = require('components/devices/views/common/base_device_settings_view');
var Device = require('models/devices');

var HandlingSettingsView = BaseDeviceSettingsView.extend({
    template: require('components/devices/templates/controller/handling_settings'),

    getInputFields: function () {
        return {
            name: {},
        };
    },

    getUpdatedModel: function (form) {
        var newField = {};
        newField[this.formData.tab] = form.name;
        return {
            circuit_names: JSON.stringify(_.extend({}, this.model.getCircuitNames(), newField)),
        };
    },

    getNewModel: function (form, parent_id) {
        return new Device.Model({
            parent: parseInt(parent_id) || 0,
            name: form.name,
            station: parseInt(form.station) || 0,
            key_number: parseInt(form.key_number) || 0,
            category: Consts.Category.Controller,
        });
    },
});

module.exports = HandlingSettingsView;
